<template>
    <app-layout>
        <div
            class="player-page"
        >
            <div class="player-wrapper">
                <div
                    class="player-container"
                    v-if="started"
                >
                    <video-player
                        ref="videoPlayer"
                        :video-source="channelUrl"
                        :unmuted="unmuted"
                        :is-live-delivery-player="true"
                        @muteChanged="setUnmuted"
                    ></video-player>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@/components/partials/app-layout.vue';
import VideoPlayer from 'gcmcn-common/src/components/video-player.vue';
export default {

    name: 'channel',
    components:{
        AppLayout,
        VideoPlayer
    },
    data () {
        return {
            uid: '',
            channelUrl: '',
            started: false,
            unmuted: true,
        };
    },
    mounted(){
        this.getVideoUrl();
    },
    watch:{
        '$route.params.channelUid': function(){
            if(this.started){
                this.started = false;
                this.getVideoUrl();
            }
        },
    },
    methods:{
        getVideoUrl(){
            this.uid = this.$route.params.channelUid;
            this.$store.dispatch('remoteGet', {url: `get-preview-url/${this.uid}`})
            .then(res=>{
                this.$set(this, 'channelUrl', res.data.preview_url);
                this.started = true;
            });
        },
        setUnmuted(playerMuted) {
            if(this.unmuted === playerMuted){
                this.unmuted = !playerMuted;
            }
        },
    }
};
</script>

<style lang="scss" scoped>
    .player-page{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .player-wrapper{
            width: 100%;
            display: flex;
            justify-content: center;
            .player-container{
                width: 854px;
                height: calc(56.25vw - 169px);
                max-height: 480px;
                margin: 0 3rem;
            }
            .player-start-wrapper{
                background-color : #111;
                color: white;
                width: 854px;
                // Used to keep 16:9 ratio,
                // 169px = sideBar width (229px) - div margin (60px)
                height: calc(56.25vw - 169px);
                max-height: 480px;
                margin: 0 3rem;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                .player-start-container{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    .star-icon{
                        font-size : 40px
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/page/Channel/index.vue